module.exports = __webpack_public_path__ + "img/zhang_3.44cd1968.jpg";